
import React from "react";
import { BrowserRouter as Router , Routes , Route } from "react-router-dom";
import DrawerTab from "./DrawerTab";
import Home from "./Home";
import About from "./About";
import Projects from "./Projects";
import Research from "./Research";
import Footer from "./Footer";
import Calendly from "./Calendly";
import GoogleTranslate from "./Translategoogle";

function App(){
       
  return (
   <>
     <Router>    
        <DrawerTab/>
        <GoogleTranslate/>
           <Routes>
             <Route exact path='/' element={<Home/>}/>
             <Route exact path='/About' element={<About/>}/>
             <Route exact path='/Projects' element={<Projects/>}/>
             <Route exact path='/Research' element={<Research/>}/>
             <Route exact path='/Calendly' element={<Calendly/>}/>
           </Routes>
        <Footer/>   
     </Router>
   </>
  )
}
           
export default App;
         
     
